module.exports = __webpack_public_path__ + "img/green1.e7b51f65.jpg";